import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'imgThumb',
    standalone: false
})
export class ImgThumbPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
